// app/scripts/product-form.js
if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = document.getElementById("service-atc-form");
      this.variantInput = this.form?.querySelector("[data-variant-id]");
      this.packageButtons = this.querySelectorAll("[data-package]");
      this.priceElement = this.querySelector("[data-price]");
      this.comparePriceElement = this.querySelector("[data-compare-price]");
      this.savingsElement = this.querySelector("[data-savings]");
      this.submitButton = this.querySelector('button[type="submit"]');
      this.usernameInput = this.querySelector("[data-username]");
      this.serviceInput = this.form?.querySelector('input[name="properties[Service]"]');
      this.originalButtonText = null;
    }
    connectedCallback() {
      this.addEventListener("click", this.onClick);
      this.addEventListener("change", this.onChange);
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmit);
      }
      const defaultButton = this.querySelector("[data-package].is-selected");
      if (defaultButton && this.variantInput) {
        const defaultRadio = defaultButton.querySelector('input[type="radio"]') || defaultButton;
        this.variantInput.value = defaultRadio.dataset.variantId || "";
        const formattedPrice = defaultRadio.dataset.variantPriceFormatted;
        const formattedComparePrice = defaultRadio.dataset.variantComparePriceFormatted;
        const formattedSavings = defaultRadio.dataset.variantSavingsFormatted;
        if (formattedPrice) {
          this.__updatePriceDisplay(formattedPrice, formattedComparePrice, formattedSavings);
        }
        if (this.serviceInput && defaultRadio.dataset.originalTitle) {
          this.serviceInput.value = defaultRadio.dataset.originalTitle;
        }
        if (this.usernameInput instanceof HTMLInputElement) {
          this.__updateUsernameInputName(defaultRadio.dataset.productProperties || "");
          this.__updateUrlLabel(defaultRadio.dataset.productProperties);
        }
        const defaultProductId = defaultRadio.dataset.productId;
        if (defaultProductId) {
          this.__loadBundle(defaultProductId);
        }
      }
    }
    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("change", this.onChange);
      if (this.form) {
        this.form.removeEventListener("submit", this.onSubmit);
      }
    }
    onChange = (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches('input[type="radio"][name="package-radio"]')) {
        const packageButton = event.target.closest("[data-package]");
        if (packageButton) this.__changeVariant(packageButton);
      }
    };
    onClick = (event) => {
      const packageButton = event.target.closest("[data-package]");
      if (packageButton) {
        event.preventDefault();
        this.__changeVariant(packageButton);
        return;
      }
      const submitButton = event.target.closest('button[type="submit"]');
      if (submitButton && this.form) {
        event.preventDefault();
        this.form.requestSubmit();
      }
    };
    __changeVariant(button) {
      const radio = button.querySelector('input[type="radio"]') || button;
      const variantId = radio.dataset.variantId;
      const productId = radio.dataset.productId;
      const formattedPrice = radio.dataset.variantPriceFormatted;
      const formattedComparePrice = radio.dataset.variantComparePriceFormatted;
      const formattedSavings = radio.dataset.variantSavingsFormatted;
      const originalTitle = radio.dataset.originalTitle;
      const productProperties = radio.dataset.productProperties;
      const reactionTitle = radio.dataset.reactionTitle;
      const reactionsList = radio.dataset.reactionsList;
      const productProperties2 = radio.dataset.productProperties2;
      if (!variantId || !this.variantInput)
        return;
      this.variantInput.value = variantId;
      window.ifCommentValidation?.refresh(this);
      requestAnimationFrame(() => {
        if (productId) {
          this.__loadBundle(productId);
        }
        if (this.serviceInput && originalTitle) {
          this.serviceInput.value = originalTitle;
        }
        if (this.usernameInput instanceof HTMLInputElement) {
          this.__updateUsernameInputName(productProperties || "");
          this.__updateUrlLabel(productProperties);
        }
        this.__updateReactionSelect(reactionTitle, reactionsList);
        this.__updateProperties2(productProperties2);
        this.packageButtons.forEach((btn) => {
          const isTarget = btn === button;
          const packageRadio = btn.querySelector('input[type="radio"]');
          if (packageRadio) packageRadio.checked = isTarget;
          if (isTarget) {
            btn.classList.add("is-selected");
          } else {
            btn.classList.remove("is-selected");
          }
          const titleEl = btn.querySelector(".package-title");
          const discountEl = btn.querySelector(".package-discount");
          const discountIconEl = btn.querySelector(".package-discount-icon");
          if (titleEl) {
            titleEl.classList.toggle("text-white", isTarget);
            titleEl.classList.toggle("text-slate-900", !isTarget);
          }
          if (discountEl) {
            discountEl.classList.toggle("text-white", isTarget);
            discountEl.classList.toggle("text-orange-500", !isTarget);
            if (isTarget)
              discountEl.classList.remove("text-orange-100");
          }
          if (discountIconEl) {
            discountIconEl.classList.toggle("text-white", isTarget);
            discountIconEl.classList.toggle("text-orange-500", !isTarget);
          }
        });
        if (formattedPrice && this.priceElement) {
          this.__updatePriceDisplay(formattedPrice, formattedComparePrice, formattedSavings);
        }
      });
    }
    __updatePriceDisplay(formattedPrice, formattedComparePrice, formattedSavings) {
      if (!formattedPrice || !this.priceElement)
        return;
      this.priceElement.textContent = formattedPrice.replace(/<[^>]*>/g, "").trim();
      if (formattedComparePrice && this.comparePriceElement) {
        this.comparePriceElement.textContent = formattedComparePrice.replace(/<[^>]*>/g, "").trim();
        this.comparePriceElement.classList.remove("hidden");
      } else if (this.comparePriceElement) {
        this.comparePriceElement.classList.add("hidden");
      }
      if (formattedSavings && this.savingsElement) {
        const icon = this.savingsElement.querySelector("svg");
        this.savingsElement.innerHTML = "";
        if (icon) {
          this.savingsElement.appendChild(icon.cloneNode(true));
        }
        this.savingsElement.appendChild(
          document.createTextNode(
            ` Save ${formattedSavings.replace(/<[^>]*>/g, "").trim()}`
          )
        );
        this.savingsElement.classList.remove("hidden");
      } else if (this.savingsElement) {
        this.savingsElement.classList.add("hidden");
      }
    }
    onSubmit = async (event) => {
      event.preventDefault();
      event.stopPropagation();

      // INP fix: instant visual feedback BEFORE validation/sync queries.
      // Setting data-loading triggers a cheap repaint so INP measures here
      // (~16ms) instead of waiting for validation+fetch chain.
      const submitBtn = event.submitter instanceof HTMLElement ? event.submitter : this.submitButton;
      if (submitBtn) submitBtn.dataset.loading = 'true';

      // Yield to let the browser paint the loading state before sync work + fetch chain.
      // scheduler.yield (Chrome 129+) falls back to setTimeout(0) elsewhere.
      await (window.scheduler?.yield?.() ?? new Promise((r) => setTimeout(r)));

      if (!this.usernameInput || !this.usernameInput.value.trim()) {
        const placeholder = this.usernameInput?.placeholder || "your link";
        this.__showError(`Please enter ${placeholder}`);
        if (submitBtn) submitBtn.dataset.loading = 'false';
        return;
      }
      if (!this.variantInput || !this.variantInput.value) {
        this.__showError("Please select a package");
        if (submitBtn) submitBtn.dataset.loading = 'false';
        return;
      }
      if (Array.from(this.form.elements).some((field) => field.matches('textarea[data-comment-min]')) &&
          !window.ifCommentValidation?.validateForm(this.form)) {
        if (submitBtn) submitBtn.dataset.loading = 'false';
        return;
      }
      if (this.submitButton) {
        this.submitButton.disabled = true;
        const span = this.submitButton.querySelector("span");
        if (span) {
          if (!this.originalButtonText) {
            this.originalButtonText = span.textContent;
          }
          span.textContent = this.submitButton.dataset.addingText || "Adding...";
        }
      }
      const formData = new FormData(this.form);
      const formProperties = this.__collectFormProperties();
      const bundleDiscountData = this.__getBundleDiscountData();
      const selectedBundleItems = this.__getSelectedBundleItems();
      if (bundleDiscountData && bundleDiscountData._bundle_discount_items && selectedBundleItems.length > 0) {
        Object.entries(bundleDiscountData).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
      }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
          method: "POST",
          body: formData
        });
        const rawText = await response.text();
        let data;
        try {
          data = JSON.parse(rawText);
        } catch (_) {
          throw new Error(response.ok ? "Unexpected response from server" : `Server error ${response.status}`);
        }
        if (!response.ok || data.status) {
          throw new Error(data.description || "Failed to add item to cart");
        }
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`);
        const updatedCart = await cartResponse.json();
        this.__handleAddToCartSuccess(updatedCart, selectedBundleItems.length > 0);
      } catch (error) {
        console.error("Add to cart error:", error);
        this.__showError(error.message || "Failed to add item to cart. Please try again.");
      } finally {
        if (submitBtn) submitBtn.dataset.loading = 'false';
        if (this.submitButton) {
          this.submitButton.disabled = false;
          const span = this.submitButton.querySelector("span");
          if (span && this.originalButtonText) {
            span.textContent = this.originalButtonText;
          }
        }
      }
    };
    __handleAddToCartSuccess(data, hasBundleItems = false) {
      const cartIcon = document.querySelector(".header-actions__cart-icon");
      if (cartIcon instanceof HTMLElement) {
        cartIcon.dataset.justUpdated = "true";
        setTimeout(() => { delete cartIcon.dataset.justUpdated; }, 500);
      }
      const itemCount = data.item_count || 1;
      const cartUpdateEvent = new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: this.id || "product-form",
          data: {
            source: "product-form",
            itemCount,
            variantId: this.variantInput.value,
            sections: data.sections || {}
          }
        }
      });
      document.dispatchEvent(cartUpdateEvent);
      if (window.ThemeEvents) {
        const themeEvent = new CustomEvent(window.ThemeEvents.cartUpdate, {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: this.id || "product-form",
            data: {
              source: "product-form",
              itemCount,
              variantId: this.variantInput.value,
              sections: data.sections || {}
            }
          }
        });
        document.dispatchEvent(themeEvent);
      }
      const cartDrawer = document.querySelector("cart-drawer-component");
      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();
      } else {
        window.location.href = "/cart";
      }
    }
    /**
     * Collects form properties from the form
     * @returns {Record<string, string>} Object with property keys and values
     */
    __collectFormProperties() {
      if (!this.form)
        return {};
      const properties = {};
      const propertyInputs = this.form.querySelectorAll(
        'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
      );
      propertyInputs.forEach((input) => {
        if (!(input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement || input instanceof HTMLSelectElement)) {
          return;
        }
        const name = input.name;
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && match[1]) {
          const propertyKey = match[1];
          let value = "";
          if (input instanceof HTMLInputElement) {
            if (input.type === "checkbox") {
              value = input.checked ? input.value || "true" : "";
            } else if (input.type === "radio") {
              if (input.checked) {
                value = input.value || "";
              }
            } else {
              value = input.value || "";
            }
          } else if (input instanceof HTMLTextAreaElement || input instanceof HTMLSelectElement) {
            value = input.value || "";
          }
          if (value !== "") {
            properties[propertyKey] = value.trim();
          }
        }
      });
      return properties;
    }
    /**
     * Gets selected bundle items from visible bundle-discount component
     * @returns {Array<{id: string, title: string, price: string}>}
     */
    __getSelectedBundleItems() {
      const bundleContainer = this.querySelector(".bundle");
      if (!bundleContainer) {
        return [];
      }
      const bundleWrappers = bundleContainer.querySelectorAll("[data-bundle-product-id]");
      let visibleBundleWrapper = null;
      for (const wrapper of bundleWrappers) {
        const style = window.getComputedStyle(wrapper);
        if (style.display !== "none") {
          visibleBundleWrapper = wrapper;
          break;
        }
      }
      if (!visibleBundleWrapper) {
        return [];
      }
      const bundleDiscountComponent = visibleBundleWrapper.querySelector("bundle-discount");
      if (!bundleDiscountComponent) {
        return [];
      }
      const selectedCheckboxes = bundleDiscountComponent.querySelectorAll(
        'input[name="bundle_products"]:checked'
      );
      if (selectedCheckboxes.length === 0)
        return [];
      const bundleItems = Array.from(selectedCheckboxes).map((checkbox) => {
        if (!(checkbox instanceof HTMLInputElement))
          return null;
        try {
          const parsedValue = JSON.parse(checkbox.value || "{}");
          return {
            id: parsedValue.id || "",
            title: parsedValue.title || "",
            price: checkbox.dataset.price || parsedValue.price || "0"
          };
        } catch (error) {
          console.warn("Failed to parse bundle item:", checkbox.value);
          return null;
        }
      }).filter((item) => item !== null && item.id && item.title);
      return bundleItems;
    }
    /**
     * Gets bundle discount data from bundle-discount component
     * @returns {{ _bundle_discount_items: string; _bundle_discount_value: string; _bundle_discount_percent: string } | null}
     */
    __getBundleDiscountData() {
      const bundleContainer = this.querySelector(".bundle");
      if (!bundleContainer)
        return null;
      const bundleWrappers = bundleContainer.querySelectorAll("[data-bundle-product-id]");
      let visibleBundleWrapper = null;
      for (const wrapper of bundleWrappers) {
        const style = window.getComputedStyle(wrapper);
        if (style.display !== "none") {
          visibleBundleWrapper = wrapper;
          break;
        }
      }
      if (!visibleBundleWrapper)
        return null;
      const bundleDiscountComponent = visibleBundleWrapper.querySelector("bundle-discount");
      if (!bundleDiscountComponent)
        return null;
      const discountValue = bundleDiscountComponent.dataset.discountValue;
      const selectedCount = bundleDiscountComponent.dataset.selectedCount;
      if (!discountValue || !selectedCount || selectedCount === "0") {
        return null;
      }
      const selectedCheckboxes = bundleDiscountComponent.querySelectorAll(
        'input[name="bundle_products"]:checked'
      );
      if (selectedCheckboxes.length === 0)
        return null;
      const formProperties = this.__collectFormProperties();
      const selectedProductsArray = Array.from(selectedCheckboxes).map((checkbox) => {
        if (!(checkbox instanceof HTMLInputElement))
          return null;
        try {
          const parsedValue = JSON.parse(checkbox.value || "{}");
          return {
            id: parsedValue.id || "",
            title: parsedValue.title || "",
            price: checkbox.dataset.price || parsedValue.price || "0",
            properties: { ...formProperties }
          };
        } catch (error) {
          console.warn("Failed to parse bundle item:", checkbox.value);
          return null;
        }
      }).filter((item) => item !== null && item.id && item.title);
      return {
        _bundle_discount_items: JSON.stringify(selectedProductsArray),
        _bundle_discount_value: discountValue,
        _bundle_discount_percent: `${discountValue}%`
      };
    }
    /**
     * Loads bundle for the selected product by showing/hiding bundle containers
     * @param {string} productId - The product ID to load bundle for
     */
    __loadBundle(productId) {
      const bundleContainer = this.querySelector(".bundle");
      // Bundle UI is gated via {% if false %} in section-form-order.liquid — silent early-return is expected.
      if (!bundleContainer) return;
      const allBundles = bundleContainer.querySelectorAll("[data-bundle-product-id]");
      allBundles.forEach((bundle) => {
        bundle.style.display = "none";
      });
      const selectedBundle = bundleContainer.querySelector(
        `[data-bundle-product-id="${productId}"]`
      );
      if (selectedBundle) {
        selectedBundle.style.display = "";
        const bundleDiscountComponent = selectedBundle.querySelector("bundle-discount");
        if (bundleDiscountComponent) {
          const checkboxes = bundleDiscountComponent.querySelectorAll(
            'input[name="bundle_products"]'
          );
          checkboxes.forEach((checkbox) => {
            if (checkbox instanceof HTMLInputElement) {
              checkbox.checked = false;
            }
          });
          const firstCheckbox = checkboxes[0];
          if (firstCheckbox) {
            const changeEvent = new Event("change", { bubbles: true });
            firstCheckbox.dispatchEvent(changeEvent);
          }
        }
      } else {
        console.warn(`Bundle not found for product ID: ${productId}`);
      }
    }
    __updateUsernameInputName(productProperties) {
      if (!(this.usernameInput instanceof HTMLInputElement))
        return;
      const fallback = this.querySelector("[data-url-label]")?.childNodes[0]?.textContent?.trim() || "Post URL";
      this.usernameInput.name = `properties[${productProperties || fallback}]`;
    }
    __updateUrlLabel(productProperties) {
      // Only update if the switching product has the metafield set.
      // If empty, preserve the current label — inconsistent admin data
      // should not cause the label to jump to a different value.
      const label = this.querySelector("[data-url-label]");
      if (!label || !productProperties) return;
      label.childNodes[0].textContent = productProperties + " ";
    }
    __updateProperties2(properties2) {
      const container = this.querySelector("[data-properties2-container]");
      const textarea = this.querySelector("[data-properties2]");
      if (!container || !textarea) return;
      // Container exists = Liquid already decided this collection needs the field.
      // Always keep it visible. Update label/name only when the product has the metafield.
      if (properties2) {
        textarea.name = `properties[${properties2}]`;
        textarea.placeholder = properties2;
        const label = container.querySelector("label");
        if (label) label.childNodes[0].textContent = properties2 + " ";
      }
      container.style.display = "";
      textarea.required = true;
    }
    __updateReactionSelect(reactionTitle, reactionsList) {
      const container = this.querySelector("[data-reaction-container]");
      const select = this.querySelector("[data-reaction-select]");
      if (!select) return;
      if (!reactionTitle && !reactionsList) {
        if (container) container.style.display = "none";
        return;
      }
      if (container) container.style.display = "";

      const fieldLabel = reactionTitle || "Commenter Gender";
      select.name = `properties[${fieldLabel}]`;
      const label = container?.querySelector("label");
      if (label) label.textContent = fieldLabel;
      if (reactionsList) {
        const opts = reactionsList.split(",").map((s) => s.trim()).filter(Boolean);
        if (opts.length) {
          select.replaceChildren(...opts.map((opt) => new Option(opt, opt)));
        }
      }
    }
    __extractPlatform(productProperties) {
      const match = productProperties?.match(/^(\w+)\s+/i);
      if (match?.[1])
        return match[1].toLowerCase();
      const urlMatch = window.location.pathname.match(/\/collections\/([^/]+)/);
      if (urlMatch?.[1])
        return urlMatch[1].split("-")[0] || "";
      return "";
    }
    __capitalize(str) {
      if (!str)
        return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    __showError(message) {
      let errorElement = this.querySelector("[data-error-message]");
      if (!errorElement) {
        errorElement = document.createElement("p");
        errorElement.setAttribute("data-error-message", "");
        errorElement.className = "mt-2 text-red-600 text-sm";
        if (this.usernameInput && this.usernameInput.parentElement) {
          this.usernameInput.parentElement.appendChild(errorElement);
        }
      }
      errorElement.textContent = message;
      errorElement.classList.remove("hidden");
      setTimeout(() => {
        if (errorElement) {
          errorElement.classList.add("hidden");
        }
      }, 5e3);
    }
    __showSuccess(message) {
      let successElement = this.querySelector("[data-success-message]");
      if (!successElement) {
        successElement = document.createElement("p");
        successElement.setAttribute("data-success-message", "");
        successElement.className = "mt-2 text-green-600 text-sm";
        if (this.form) {
          this.form.insertBefore(successElement, this.form.firstChild);
        }
      }
      successElement.textContent = message;
      successElement.classList.remove("hidden");
      setTimeout(() => {
        if (successElement) {
          successElement.classList.add("hidden");
        }
      }, 3e3);
    }
  }
  customElements.define("product-form", ProductForm);
}

